import { useState, useEffect } from "react";
import problemServices from "app/services/problem-service";

const useProblemDetails = ({ name, id }) => {
  const [problemData, setProblemData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProblem = async () => {
      if (!name && !id) {
        setError("Invalid parameters: name or id required");
        setProblemData(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = id
          ? await problemServices.getProblemById(id)
          : await problemServices.getProblemDetails(name);

        if (!data) {
          throw new Error("No problem data returned");
        }

        setProblemData(data);
      } catch (err) {
        console.error("Error fetching problem:", err);
        const errorResponse = err.response?.data || {
          message: err.message || "Failed to fetch problem details",
          status: err.response?.status || 400,
        };
        setError(errorResponse);
        setProblemData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProblem();
  }, [name, id]);

  return { problemData, loading, error };
};

export default useProblemDetails;
